<template>
  <v-container fluid>
    <v-card outlined elevation="0">
      <div v-if="!loading && chatIDs && chatIDs.length === 0" class="pa-2 text-center">Nenhum ID do huggy configurado</div>
      <div v-else-if="!loading && lastTickets.length === 0" class="pa-2 text-center">Nenhuma conversa para o filtro solicitado</div>
      <v-list v-else class="pb-0 pt-0">
        <v-list-item v-if="!loading">
          <v-list-item-content>
            <v-list-item-subtitle class="text-right">Página {{ currentPage + 1 }} · {{ lastTickets.length }} {{ lastTickets.length === 1 ? 'conversa' : 'conversas' }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="!loading" />
        <template v-for="(item, index) in lastTickets">
          <v-divider v-if="index > 0" :key="'divider-' + item.id" />
          <v-list-item two-line :key="'item-' + item.id" @click="openChatDetails(item)">
            <v-list-item-content>
              <v-list-item-title>#<b>{{ item.id }}</b> <v-chip x-small class="ml-2" label :color="item.closedAt ? 'success' : 'primary'">{{ item.closedAt ? 'Encerrado' : 'Aberto' }}</v-chip></v-list-item-title>
              <v-list-item-subtitle>{{ item.createdAt | moment('DD/MM/YYYY HH:mm') }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>
        <v-divider v-if="loading" />
        <v-list-item v-if="loading">
          <v-list-item-content>
            <v-list-item-title class="text-center">Carregando...</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider v-if="!loading && lastTickets.length > 0" />
      <v-row v-if="!loading && lastTickets.length > 0" no-gutters class="pa-2" justify="center">
        <v-btn icon :disabled="currentPage === 0" @click="changePage(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn icon :disabled="!hasNextPage" @click="changePage(1)">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-row>
    </v-card>
    <huggy-details-dialog :openedChat="openedChat" @close="openedChat = null" />
  </v-container>
</template>

<script>
import axios from 'axios'
import HuggyDetailsDialog from '@/components/HuggyDetailsDialog'
import { getChats } from '@/services/huggyAPI'

export default {
  name: 'TicketTabList',
  components: {
    HuggyDetailsDialog
  },
  props: {
    id: {
      type: String,
      default: null
    },
    customerID: {
      type: String,
      default: null
    },
    reference: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      loading: false,
      lastTickets: [],
      chatIDs: [],
      openedChat: null,
      currentPage: 0,
      hasNextPage: false
    }
  },
  computed: {},
  methods: {
    openChatDetails (item) {
      this.openedChat = item
    },
    async getCustomerChatID (id) {
      try {
        const { data } = await axios.get(`customers/${id}`)
        return (data && data.chat_ids) || []
      } catch (error) {
        return false
      }
    },
    async getTickets () {
      this.loading = true
      this.lastTickets = []
      if (this.chatIDs && this.chatIDs.length > 0) {
        try {
          const allChats = []
          let anyPageFull = false
          for (const contactId of this.chatIDs) {
            const chats = await getChats({ contact: contactId, page: this.currentPage })
            if (chats.length >= 20) anyPageFull = true
            allChats.push(...chats)
          }
          allChats.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          this.lastTickets = allChats
          this.hasNextPage = anyPageFull
        } catch (error) {
          console.log('problema no get', error)
        }
      }
      this.loading = false
    },
    changePage (direction) {
      this.currentPage += direction
      this.getTickets()
    }
  },
  async mounted () {
    this.loading = true
    if (this.customerID) {
      const chatIDs = await this.getCustomerChatID(this.customerID) || []
      this.chatIDs = [...this.chatIDs, ...chatIDs]
    }
    this.getTickets()
  }
}
</script>
